import React, { useState } from "react";
import TigerPaw from "../../Assets/Icons/Images.png";
import TigerPawHover from "../../Assets/Icons/colored_images.png";

const IndividualTigerContainer = ({
  organizedData,
  handleGroupClick,
  type,
}) => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <div className="Images_Table" style={{ position: "relative" }}>
      <div className="Images_View Tiger_Views">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "start",
            alignItems: "start",
            gap: "2vw",
            padding: "2vh 0",
            ...(type === "bulkupload" && {
              marginLeft: "-200px",
              marginTop: "-200px",
            }),
          }}
        >
          {organizedData.map(([speciesId, count]) => {
            const isHovered = hoveredId === speciesId;

            return (
              <div
                key={speciesId}
                className="image-folder"
                style={{ width: "10vw", height: "13vh" }}
                onClick={() =>
                  handleGroupClick(
                    speciesId === "null" ? "unclassified" : speciesId
                  )
                }
                onMouseEnter={() => setHoveredId(speciesId)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <img
                  src={isHovered ? TigerPawHover : TigerPaw}
                  alt="Tiger-Paw"
                  style={{ height: "3vh", width: "auto" }}
                />
                <div className="folder-title">
                  {speciesId === "null" ? "Unidentified" : speciesId}
                </div>
                <div className="folder-count">{count}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default IndividualTigerContainer;
